import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBS2F0nHiHbDOOl0HSUzG6jybJwwfAwZ-s",
  authDomain: "clone-47a8a.firebaseapp.com",
  databaseURL: "https://clone-47a8a.firebaseio.com",
  projectId: "clone-47a8a",
  storageBucket: "clone-47a8a.appspot.com",
  messagingSenderId: "333855411849",
  appId: "1:333855411849:web:a18001ec21a171731a0058",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
